'use strict';


export default function ($http, $timeout, $parse) {
	'ngInject';

	return {
		require: '^ngModel',
		link: link,
		scope: {
			gql: '<',
			variables: '<',
			refetchInterval: '<',
			refetchOnFocus: '<',
			context: '<',
		},
	};

	function link(scope, element, attrs, ngModelCtrl) {
		const state = {
			loading: false,
			fetched: false,
			lastFetch: null,
			data: {},
			copy: (data) => angular.copy(data),
			log: (data) => console.log(data),
			refetch: (variables) => executeQuery(variables),
		};
		ngModelCtrl.$setViewValue(state);

		let refetchTimeout;
		let focusListener;

		function executeQuery(variables) {
			if (state.loading) return;
			state.loading = true;
			const data = { query: scope.gql, variables: variables || scope.variables };
			$http.post('/api/flux/graphql/', data, { cache: !!scope.cache }).then((response) => {
				state.data = response.data.data;
				state.errors = response.data.errors;
				try {
					if (attrs.onLoad) {
						$parse(attrs.onLoad)(scope, { $context: scope.context, $response: response });
					}
				} catch (e) {
					console.error(e);
				}
			}, (error) => {
				state.errors = error.data.errors;
			}).finally(() => {
				state.fetched = true;
				state.loading = false;
				state.lastFetch = new Date();
				if (scope.refetchInterval) {
					if (refetchTimeout) $timeout.cancel(refetchTimeout);
					refetchTimeout = $timeout(executeQuery, scope.refetchInterval);
				}
			});

		}

		executeQuery();

		if (scope.refetchOnFocus) {
			window.addEventListener('focus', (e) => {
				if (new Date() - state.lastFetch > 10000) {
					executeQuery();
				}
			})
		}

		scope.$on('$destroy', () => {
			console.log('GraphQL scope destroyed, cleaning up...');
			if (refetchTimeout) {
				$timeout.cancel(refetchTimeout);
			}
			if (focusListener) {
				window.removeEventListener(focusListener);
			}
		});
	}
}
